import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Article } from '../models/article';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  constructor(private http: HttpClient) { }
  
    public getArticles() : Observable<Article[]> {
      return this.http.get<Article[]>(`${environment.API_URL}/articles`);
    }

    public createArticle(article: Article) : Observable<Article> {
      return this.http.post<Article>(`${environment.API_URL}/articles/create`, article);
    }

    public updateArticle(article: Article) : Observable<Article> {
      return this.http.post<Article>(`${environment.API_URL}/articles/update`, article);
    }

    public deleteArticle(id: number) : Observable<void>{
      return this.http.post<void>(`${environment.API_URL}/articles/delete`, {id: id});
    }
}
